import React from 'react';

// End screen for flows that produce no generated document (no `outputLabel`),
// e.g. the agreement classifier — whose result is shown on the preceding item.
export function FlowComplete() {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
      <div className="theEnd space-y-3 text-center">
        <h2 className="font-display text-3xl font-medium tracking-tight text-primary-900">
          You've reached the end
        </h2>
        <p className="text-gray-500">
          You can revisit any of your answers from the navigation on the left.
        </p>
      </div>
    </div>
  );
}
